export enum LangsEnum {
  HY = 'hy',
  EN = 'en',
}
